document.addEventListener('DOMContentLoaded', () => {
  const copyBtn = document.querySelector(
    '.copy-url-btn',
  ) as HTMLButtonElement | null;
  if (!copyBtn) return;

  copyBtn.addEventListener('click', () => {
    const url = window.location.href;
    navigator.clipboard
      .writeText(url)
      .then(() => {
        showToast('Odkaz bol skopírovaný do schránky!');
      })
      .catch((err) => {
        console.error('Nepodarilo sa skopírovať URL:', err);
      });
  });
});

// Jednoduchá funkcia pre zobrazenie toast notifikácie
function showToast(message: string) {
  const toast = document.createElement('div');
  toast.textContent = message;
  toast.style.position = 'fixed';
  toast.style.bottom = '20px';
  toast.style.right = '20px';
  toast.style.background = '#2e2e2e';
  toast.style.color = '#fff';
  toast.style.padding = '10px 20px';
  toast.style.borderRadius = '12px';
  toast.style.boxShadow = '0 2px 6px rgba(0,0,0,0.3)';
  toast.style.zIndex = '9999';
  toast.style.opacity = '0';
  toast.style.transition = 'opacity 0.3s ease';

  document.body.appendChild(toast);

  // Animácia fade-in
  requestAnimationFrame(() => {
    toast.style.opacity = '1';
  });

  // Animácia fade-out a odstránenie po 3s
  setTimeout(() => {
    toast.style.opacity = '0';
    toast.addEventListener('transitionend', () => {
      toast.remove();
    });
  }, 3000);
}
